import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";

  const DataTypeFilter = ({
    handleApplyFilters,
    currentDataTypes,
    filters,
    isRTL,
    t,
  }) => {
    const currentDataType = currentDataTypes.find(
      (type) => type.value === filters.dataType
    );

    return (
      <Box h="full">
        <Menu>
          <MenuButton
            w="full"
            variant="outline"
            size="sm"
            textAlign={isRTL ? "right" : "left"}
            h="40px"
            display="flex"
            alignItems="center"
          >
            <HStack spacing={2} w="full" justify={isRTL ? "flex-end" : "flex-start"}>
              {isRTL && <Icon as={FaChevronDown} />}
              <Text noOfLines={1} flex={1}>
                {currentDataType?.label || t("reports.select", "اختر")}
              </Text>
              {!isRTL && <Icon as={FaChevronDown} />}
            </HStack>
          </MenuButton>
          <MenuList>
            {currentDataTypes.map((type) => (
              <MenuItem
                key={type.value}
                onClick={() => handleApplyFilters({ dataType: type.value })}
                fontWeight={type.value === filters.dataType ? "bold" : "normal"}
                bg={type.value === filters.dataType ? "blue.50" : "white"}
                textAlign={isRTL ? "right" : "left"}
              >
                {type.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
    );
  };
export default DataTypeFilter;
